<template>
  <div class="mind-map-container content_w_710" :class="device.isMobile ? 'mind-map-container-mobile' : ''" :id="content.key" >
    <div class="mind-map-box" :style="{
      height:content.height?content.height+'rem':'300rem'

    }">
      <div class="mind-map" :id="`${content.key}-1`" @touchmove="(e) => { e.preventDefault() }"></div>
    </div>
    <div class="mind-map-bottom">
      <el-button type="text" @click.stop="resetLayout">
        <span class="icon el-icon-aim"></span>
      </el-button>
      <el-button type="text" @click.stop="exportImage">
        <span class="icon el-icon-download"></span>
      </el-button>
    </div>
    <p
      class="mind-map-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
      }"
      v-html="content.title"
    ></p>
  </div>
</template>
<script>
/*
脑图组件
*/
import MindMap from 'simple-mind-map'
import MiniMap from 'simple-mind-map/src/plugins/MiniMap.js'
import Watermark from 'simple-mind-map/src/plugins/Watermark.js'
import KeyboardNavigation from 'simple-mind-map/src/plugins/KeyboardNavigation.js'
import ExportPDF from 'simple-mind-map/src/plugins/ExportPDF.js'
import ExportXMind from 'simple-mind-map/src/plugins/ExportXMind.js'
import Export from 'simple-mind-map/src/plugins/Export.js'
// import RichText from 'simple-mind-map/src/plugins/RichText.js'
import Drag from 'simple-mind-map/src/plugins/Drag.js'
import Select from 'simple-mind-map/src/plugins/Select.js'
import AssociativeLine from 'simple-mind-map/src/plugins/AssociativeLine.js'
import TouchEvent from 'simple-mind-map/src/plugins/TouchEvent.js'
import NodeImgAdjust from 'simple-mind-map/src/plugins/NodeImgAdjust.js'
import SearchPlugin from 'simple-mind-map/src/plugins/Search.js'
import Painter from 'simple-mind-map/src/plugins/Painter.js'
// import Formula from 'simple-mind-map/src/plugins/Formula.js'
import RainbowLines from 'simple-mind-map/src/plugins/RainbowLines.js'
import Demonstrate from 'simple-mind-map/src/plugins/Demonstrate.js'
import OuterFrame from 'simple-mind-map/src/plugins/OuterFrame.js'
// // 注册插件
MindMap.usePlugin(MiniMap)
  .usePlugin(Watermark)
  .usePlugin(Drag)
  .usePlugin(KeyboardNavigation)
  .usePlugin(ExportPDF)
  .usePlugin(ExportXMind)
  .usePlugin(Export)
  // .usePlugin(RichText)
  .usePlugin(Select)
  .usePlugin(AssociativeLine)
  .usePlugin(NodeImgAdjust)
  .usePlugin(TouchEvent)
  .usePlugin(SearchPlugin)
  .usePlugin(Painter)
  // .usePlugin(Formula)
  .usePlugin(RainbowLines)
  .usePlugin(Demonstrate)
  .usePlugin(OuterFrame)

export default {
  name: "mindMap",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      mindMap: null,
      rem: 0,
    }
  },
  mounted() {
    this.initRem();
    this.$nextTick(() => {
      setTimeout(() => {
        this.loadMindMap();
      }, 1000)
    })
  },
  methods: {
    initRem() {
      let width = window.document.documentElement.getBoundingClientRect().width;
      if (!this.device.isMobile) {
        width = 750;
      }else{
        width = width > 750 ? 750 : width;
      }
      this.rem = width / 750; // 将屏幕宽度分为10份， 1份为1rem
    },
    loadMindMap(data) {
      data = data || JSON.parse(JSON.stringify(this.content.content));
      let element = document.getElementById(`${this.content.key}-1`);
      // 创建脑图
      this.mindMap = new MindMap({
        el: element,
        data,
        fitPadding: 20,
        exportPaddingX: 20,
        exportPaddingY: 50,
        // isDisableDrag: true,
        readonly: true,
        isLimitMindMapInCanvas: true,
        alwaysShowExpandBtn: true,
        resetCss: `*{ margin: 0; padding: 0; box-sizing: content-box; font-size: ${this.device.isMobile ? (28 * this.rem) : 20}px; }`,
        // isUseCustomNodeContent: true,
        // customCreateNodeContent: (node) => {
        //   let div = document.createElement('div');
        //   div.className = 'mind-map-item';
        //   div.innerHTML = node.nodeData.data.text;
        //   return div
        // }
      });
      this.mindMap.setData(data);
      // 节点树渲染完毕 自适应显示整体脑图
      this.mindMap.on('node_tree_render_end', () => {
        this.mindMap.view.fit()
      })
    },
    resetLayout() {
      new Promise((resolve) => {
        let newData = null
        if(this.mindMap) {
          newData = this.mindMap.getData()
          this.mindMap.destroy()
          this.mindMap = null
        }
        this.loadMindMap(newData)
        resolve()
      }).then(() => {
        setTimeout(() => {
          this.mindMap.execCommand('RESET_LAYOUT')
        }, 300)
      })
    },
    exportImage() {
      if(!this.mindMap) return
      
      new Promise((resolve) => {
        this.mindMap.destroy()
        this.mindMap = null
        this.loadMindMap(this.allExpandData(this.content.content))
        // this.mindMap.setData(this.allExpandData(this.content.content));
        resolve()
      }).then(() => {
        // this.mindMap.render(() => {
        setTimeout(() => {
          // this.mindMap.export('png')
          this.mindMap.doExport.export('png', false).then((res) => {
            const filename = '思维导图.png'
            if(this.device.isMobile && this.device.isApp) {
              if(this.device.isIos) {
                if (window.webkit) {
                  window.webkit.messageHandlers.jsCallOCFunction.postMessage({
                    type: -14,
                    imgName: filename,
                    img: res
                  });
                }
              }else{
                window.Android.HtmlToAndroid(JSON.stringify({
                  type: -14,
                  imgName: filename,
                  img: res
                }));
              }
            }else{
              let blob = this.base64ToBlob(res)  // 转码
              const url = URL.createObjectURL(blob)
              const a = document.createElement('a')
              document.body.appendChild(a)
              a.href = url
              a.target = "_blank"
              a.download = filename
              a.click();
              window.URL.revokeObjectURL(url)
              document.body.removeChild(a)
            }
          }).catch(err => {
            console.log(err)
          })
        }, 500)
        // })
      })

      // this.mindMap.updateData(JSON.parse(JSON.stringify(this.content.content)))
      // this.mindMap.view.fit()
      // // this.mindMap.render()

      // this.mindMap.on('node_tree_render_end', () => {
      //   this.mindMap.export('png')
      //   // this.mindMap.doExport().png()
      // })

      // return
    },
    allExpandData(content) {
      let newContent = JSON.parse(JSON.stringify(content))
      newContent.children.map(item => {
        if(!item.data.expand) {
          item.data.expand = true
        }
        if(item.children && item.children.length > 0) {
          return this.allExpandData(item)
        }
        return item;
      })
      return newContent
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new window.Blob([uInt8Array], {type: contentType});
    },
  }
}
</script>
<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 30rem auto;
}
.mind-map-container{
  position: relative;

  .mind-map-bottom{
    position: absolute;
    bottom: 30rem;
    right: 20rem;
    padding: 5rem;

    .icon{
      font-size: 20rem;
    }
  }

  .mind-map-box{
    width: 100%;
    height:300rem;
    position: relative;

    .mind-map{
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .mind-map-title{
    display: block;
    margin-top: 15rem;
    width: 100%;
    text-align: center;
    font-size: 16rem;
    line-height: 20rem;
    color: #666;
  }
}
.mind-map-container-mobile{
  margin: 60rem auto;

  .mind-map-box{
    .mind-map{
      font-size: 30rem;
    }
  }

  .mind-map-title{
    margin-top: 15rem;
    font-size: 20rem;
    line-height: 32rem;
    color: #666;
  }
}
</style>